import React, {useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import Select from "../../../common/Select";
import {productSelector, setQuantity} from "../../ducks/product";

import styles from "./quantity.module.scss";

export default function Quantity() {
  const dispatch = useDispatch();
  const {circulations, condition} = useSelector(productSelector);

  const options = useMemo(() => circulations.map(({minQuantity, pricePerItem}) => ({
    label: `${minQuantity} шт. - ${pricePerItem}₽ за шт.`,
    value: minQuantity
  })), [circulations]);

  return (
    <div className={styles.root}>
      <span>Тираж:</span>
      <Select
        className={styles.select}
        size="small"
        options={options}
        value={condition.quantity}
        onChange={(e) => dispatch(setQuantity(e.target.value))}
        renderOption={(label) => label}
        renderValue={(value) => `${value} шт.`}
      />
    </div>
  );
}
